/**
 * /tenants/$slug/onboarding-autotune — route shim (DD-NEXT-7).
 *
 * Thin per the golden path: validate nothing (no search params),
 * prefetch the dashboard via ensureQueryData so the page reads a
 * warm cache, mount the feature page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchAutotuneDashboard } from "@/features/onboarding-autotune/queries";
import { queryKeys } from "@/lib/query-keys";
import { OnboardingAutotunePage } from "@/features/onboarding-autotune/pages/onboarding-autotune-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/onboarding-autotune/",
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.onboardingAutotune(context.tenant.id),
      queryFn: () => fetchAutotuneDashboard(context.tenant.id),
    }),
  component: OnboardingAutotunePage,
});
